import { Link } from "react-router-dom";
import { arrow_right } from "../../../assets/icons";
import { useContext, useEffect, useRef, useState } from "react";
import styles from "./newAdPartThree.module.css";
import AdPage from "../../../pages/AdPage/AdPage";
import { WizardContext } from "../../../Store/Wizard.store";
import { Alternative } from "../../../Models/AlternativeModel";
import { AddAlternative, updateAlternative } from "../../../Api/Services/Alternative";
import LoadingIcon from "../../LoadingIcon/LoadingIcon";

interface NewAdPartThreeProps {
    backButton: (buttonText: string) => JSX.Element;
}
export default function NewAdPartThree({backButton}: NewAdPartThreeProps) {
    const [termsAccept, setTermsAccept] = useState(false);
    const [displayError, setDisplayError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isloading, setIsLoading] = useState(false);
    const {wizardFormData, setWizardFormData} = useContext(WizardContext);
    const h2Ref = useRef<HTMLHeadingElement>(null);
    const testData = {
        id: 1,
        title: wizardFormData.adData.title,
        description: wizardFormData.adData.description,
        supplementaryInformation: wizardFormData.adData.supplementaryInformation,
        casNumber: wizardFormData.adData.casNumber,
        isBioBased: wizardFormData.adData.isBioBased,
        additionalInformation: wizardFormData.adData.additionalInformation,
        alternativeToCategories: wizardFormData.adData.alternativeToCategories,
        sectorCategories: wizardFormData.adData.sectorCategories,
        useCategories: wizardFormData.adData.useCategories,
        certificationCategories: wizardFormData.adData.certificationCategories,
        safetyDataSheet: wizardFormData.adData.safetyDataSheet,
        technicalDataSheet: wizardFormData.adData.technicalDataSheet,
        additionalDocuments: wizardFormData.adData.additionalDocuments,
        companyName: wizardFormData.adData.companyName,
        companyGroupId: 0,
        companyWebsite: wizardFormData.adData.companyWebsite,
        contactName: wizardFormData.adData.contactName,
        contactEmail: wizardFormData.adData.contactEmail,
        logotype: wizardFormData.adData.logotype,
        isPublished: false,
        publicUrl: "",
        isPopular: false,
        alternativeLevel: 0,
        createdBy: "",
    } as Alternative

    useEffect(() => {
        if (h2Ref.current) {
            h2Ref.current.scrollIntoView();
        }
    }, []);
    
    const submitAd = () => {
        if (termsAccept) {   
            setIsLoading(true);
            if (wizardFormData.editMode) {
                updateAlternative(wizardFormData.adData).then((data) => {
                    if (data.success) {
                        setWizardFormData({...wizardFormData, wizardStep: 4});
                    }else{
                        setDisplayError(true);
                        setErrorText(data.message);
                    }
                });
            }else{
                AddAlternative(wizardFormData.adData).then((data) => {
                    if (!data.StatusCode) {
                        setWizardFormData({...wizardFormData, wizardStep: 4});                    
                    }else{
                        setDisplayError(true);
                        setErrorText(data.Message);
                    }
                });
            }
        }
    };

    return(
        <div>
            {isloading && <LoadingIcon/>}
            {backButton(wizardFormData.editMode ? "Updated your ad" :"Create your ad")}
            <h2 ref={h2Ref}>Preview your ad and publish</h2>
            <div className={styles.border}>
                <AdPage alternativeData={testData} isPreview={true}/>
            </div>
            <div className={`${styles.mobile_container} `}>
                <div className={styles.terms_accept}>
                    <label htmlFor="terms-accept">Accept terms and conditions and GDPR policy</label>
                    <input type="checkbox" name="terms-accept" id="tems-accept" checked={termsAccept} onChange={() => !termsAccept}/>
                    <div
                    className={styles.checkbox}
                    onClick={() => setTermsAccept(!termsAccept)}
                    aria-describedby="terms-accept-text"
                    tabIndex={0}
                    ></div>
                    <p id="terms-accept-text">I have read and I agree to the <Link to="/terms-conditions" target="_blank">terms and conditions</Link> and <Link to="/gdpr" target="_blank">GDPR Policy</Link> for advertising at ChemSec Marketplace and confirm that no SIN list substances are present in the advertised alternative.</p>
                </div>
            </div>
            <div className={styles.buttons}>
                {backButton(wizardFormData.editMode ? "Updated your ad" :"Create your ad")}
                <button type="button" className="button button_black" onClick={submitAd}>Submit your ad {arrow_right}</button>
            </div>
            {displayError && <p className="error_text right">{errorText}</p>}
        </div>
    )
}